window.onload = function () {
  jQuery('head').append(
    '<style>#revieve-loader-fr {display: block; position: fixed; width: 100%; height: 100%; left: 0; top: 0; background-repeat: no-repeat; background-position: center center; background-color: white; background-image: url("//d38knilzwtuys1.cloudfront.net/revieve-plugin/partner/garancia/images/loader.gif"); z-index: 1900000; content: ""; opacity: 0; }</style>'
  );
};

var revieveCheckoutUrl = 'https://garancia-beauty.com/cart';
var revieveProductsInCart = false;
var intervalMs = 150;
// Loader functions:
var revieve_show_loader = function () {
  jQuery('<div id="revieve-loader-fr"></div>').appendTo(document.body);
  jQuery('#revieve-loader-fr').fadeTo('slow', 0.8);
};
var revieve_hide_loader = function () {
  jQuery('#revieve-loader-fr').fadeTo('slow', 0, function () {
    jQuery('#revieve-loader-fr').remove();
  });
};
function addProductToCart(product_id) {
  var c = jQuery.Deferred();
  var url = '/cart/add.js';
  var r = jQuery.ajax({
    url: url,
    type: 'POST',
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
    data: {
      id: product_id,
      quantity: 1,
      form_type: 'product',
    },
  });
  r.always(function (e, r) {
    window.setTimeout(function () {
      c.resolve(product_id);
    }, intervalMs);
  });
  revieveProductsInCart = true;
  return c;
}
var revieveConfig = {
  partner_id: 's7eGoxVm11',
  locale: 'fr',
  env: 'prod', // for test env. Change to prod for production deployment
  onAddToCart: function (products) {
    revieve_show_loader();
    if (Array.isArray(products)) {
      console.log('User clicked add all cart. Adding all products to shopping cart.');
      var promises = products.map(function (oneProduct) {
        return function () {
          return addProductToCart(oneProduct.id);
        };
      });
      promises.push(function () {
        revieve_hide_loader();
      });
      var maind = jQuery.Deferred();
      promises.reduce(function (prev, cur) {
        return prev.then(cur);
      }, maind);
      maind.resolve();
    } else {
      console.log('User clicked add to cart. Adding the product to shopping cart.');
      addProductToCart(products.id);
      revieve_hide_loader();
    }
  },
  onClose: function () {
    if (revieveProductsInCart) {
      window.location = revieveCheckoutUrl;
    }
  },
  onCheckout: function () {
    window.location = revieveCheckoutUrl;
  },
  onClickProduct: function (product) {
    // To be filled in by Garancia.
    console.log('User clicked info action.');
    console.log(product);
    var win = window.open(product.url, '_blank');
    win.focus();
  },
};
(function () {
  var rv = document.createElement('script');
  rv.src = 'https://d38knilzwtuys1.cloudfront.net/revieve-plugin-v4/revieve-plugin-loader.js';
  rv.charset = 'utf-8';
  rv.type = 'text/javascript';
  rv.async = 'true';
  rv.onload = rv.onreadystatechange = function () {
    var rs = this.readyState;
    if (rs && rs != 'complete' && rs != 'loaded') return;
    Revieve.Init(revieveConfig, function () {
      // Comment out the below line if you want to open the modal
      // manually when user clicks a certain button or navigates
      // to certain page.
      // Revieve.API.show();
    });
  };
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(rv, s);
})();

var revievestartButtons = document.getElementsByClassName('revievestart');
for (var i = 0; i < revievestartButtons.length; i++) {
  revievestartButtons[i].addEventListener('click', function () {
    Revieve.API.show();
  });
}
